import { useState } from "react";
import { useDataProvider, useNotify } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IRegeneratePdfForSubcontractorButton {
  id: number;
  setRefresh?: (refresh: boolean) => void;
}

const RegeneratePdfForSubcontractorButton = ({
  id,
  setRefresh,
}: IRegeneratePdfForSubcontractorButton) => {
  const provider = useDataProvider();
  const notify = useNotify();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const regeneratePdfForSubcontractorUrlInvoice = () => {
    setIsLoading(true);
    provider
      .customUpdate(
        `subcontractorPurchaseInvoices/${id}/generatePdfForSubcontractor`,
        {},
      )
      .then(({ data }: any) => {
        setIsLoading(false);
        notify("Successfully Generate PDF For Subcontractor.");
        if (setRefresh) {
          setRefresh(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
        notify("Error Generate PDF For Subcontractor.", "warning");
      });
  };

  return (
    <StyledButton
      variant="outlined"
      onClick={regeneratePdfForSubcontractorUrlInvoice}
      disabled={isLoading}
    >
      {isLoading ? "Loading" : "Regenerate PDF Subcontractor"}
    </StyledButton>
  );
};

export default RegeneratePdfForSubcontractorButton;
